/* eslint-disable */
/* THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Regenerate via src/api/scripts/generator.sh */
/* generator-hash: 044249f3305aaff503b3edfc3a38a1309004f7902f608284bd8ccc6d958eb2ed */
import { emptySplitApi as api } from '../emptyApi'
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postApproval: build.query<PostApprovalApiResponse, PostApprovalApiArg>({
      query: (queryArg) => ({
        url: `/changeofownership/Approval`,
        method: 'POST',
        body: queryArg.approvalListRequestModel,
        headers: {},
      }),
    }),
    getApprovalById: build.query<
      GetApprovalByIdApiResponse,
      GetApprovalByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/changeofownership/Approval/${queryArg.id}`,
        headers: {},
      }),
    }),
    putApprovalById: build.mutation<
      PutApprovalByIdApiResponse,
      PutApprovalByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/changeofownership/Approval/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.approvalUpdateModel,
        headers: {},
      }),
    }),
    getApprovalApprovalhandlerByClientId: build.query<
      GetApprovalApprovalhandlerByClientIdApiResponse,
      GetApprovalApprovalhandlerByClientIdApiArg
    >({
      query: (queryArg) => ({
        url: `/changeofownership/Approval/approvalhandler/${queryArg.clientId ?? ':clientId'}`,
        headers: {},
      }),
    }),
    getApprovalAnnualByClientIdAndYear: build.query<
      GetApprovalAnnualByClientIdAndYearApiResponse,
      GetApprovalAnnualByClientIdAndYearApiArg
    >({
      query: (queryArg) => ({
        url: `/changeofownership/Approval/annual/${queryArg.clientId ?? ':clientId'}/${queryArg.year}`,
        headers: {},
      }),
    }),
    getApprovalByIdPdf: build.query<
      GetApprovalByIdPdfApiResponse,
      GetApprovalByIdPdfApiArg
    >({
      query: (queryArg) => ({
        url: `/changeofownership/Approval/${queryArg.id}/pdf`,
        headers: {},
      }),
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as changeofownership }
export type PostApprovalApiResponse =
  /** status 200 OK */ ApprovalListResultModelRead
export type PostApprovalApiArg = {
  approvalListRequestModel: ApprovalListRequestModel
}
export type GetApprovalByIdApiResponse =
  /** status 200 OK */ ApprovalDetailsResultModel
export type GetApprovalByIdApiArg = {
  id: string
}
export type PutApprovalByIdApiResponse = /** status 200 OK */ boolean
export type PutApprovalByIdApiArg = {
  id: string
  approvalUpdateModel: ApprovalUpdateModel
}
export type GetApprovalApprovalhandlerByClientIdApiResponse =
  /** status 200 OK */ ApprovalWhoHandelsItEnum
export type GetApprovalApprovalhandlerByClientIdApiArg = {
  clientId?: string
}
export type GetApprovalAnnualByClientIdAndYearApiResponse =
  /** status 200 OK */ number[]
export type GetApprovalAnnualByClientIdAndYearApiArg = {
  clientId?: string
  year: number
}
export type GetApprovalByIdPdfApiResponse = /** status 200 OK */ Blob
export type GetApprovalByIdPdfApiArg = {
  id: string
}
export type ApprovalResponseModel = {
  approvalId?: string | null
  sectionNo?: string | null
  seller?: string | null
  buyer?: string | null
  handoverDate?: string | null
  status?: ApprovalStatusEnum
  deadline?: string
}
export type ApprovalListResultModel = {
  totalCount?: number
  totalPageCount?: number
  resultCount?: number
  currentPage?: number
  result?: ApprovalResponseModel[] | null
}
export type ApprovalListResultModelRead = {
  totalCount?: number
  totalPageCount?: number
  resultCount?: number
  morePages?: boolean
  currentPage?: number
  result?: ApprovalResponseModel[] | null
}
export type BblErrorModel = {
  message?: string | null
  stackTrace?: string | null
}
export type ApprovalListRequestModel = {
  clientId?: string | null
  searchText?: string | null
  searchStatus?: ApprovalSearchStatusEnum
  sortColumn?: ApprovalListSortColumn
  sortOrder?: SortOrderEnum
  take?: number
  skip?: number
}
export type PersonModel = {
  name?: string | null
  phoneNo?: string | null
  email?: string | null
  birthdate?: string | null
  isCurrentlyOwner?: boolean
}
export type BrokerModel = {
  name?: string | null
  phone?: string | null
  association?: string | null
}
export type ApprovalDetailsResultModel = {
  whoHandlesApproval?: ApprovalWhoHandelsItEnum
  status?: ApprovalStatusEnum
  processedDate?: string | null
  processedBy?: string | null
  comment?: string | null
  buyers?: PersonModel[] | null
  sellers?: PersonModel[] | null
  isInvolved?: boolean
  sectionNo?: string | null
  ssbNo?: string | null
  buildingName?: string | null
  broker?: BrokerModel
  handoverDate?: string | null
  price?: number
  deadline?: string
}
export type ApprovalUpdateModel = {
  status: ApprovalStatusEnum
  comment?: string | null
}
export enum ApprovalStatusEnum {
  ForApprovalByBoard = 'ForApprovalByBoard',
  ForApprovalByBbl = 'ForApprovalByBbl',
  NoApproval = 'NoApproval',
  ApprovedByBoard = 'ApprovedByBoard',
  ApprovedByBbl = 'ApprovedByBbl',
  ApprovedAutoByBoard = 'ApprovedAutoByBoard',
  ApprovedAutoByBbl = 'ApprovedAutoByBbl',
  RejectedByBoard = 'RejectedByBoard',
  RejectedByBbl = 'RejectedByBbl',
  Cancelled = 'Cancelled',
}
export enum ApprovalSearchStatusEnum {
  All = 'All',
  ForApproval = 'ForApproval',
  Approved = 'Approved',
  Rejected = 'Rejected',
}
export enum ApprovalListSortColumn {
  SectionNo = 'SectionNo',
  HandoverDate = 'HandoverDate',
  Status = 'Status',
  Deadline = 'Deadline',
}
export enum SortOrderEnum {
  Ascending = 'Ascending',
  Descending = 'Descending',
}
export enum ApprovalWhoHandelsItEnum {
  NoOne = 'NoOne',
  Board = 'Board',
  Bbl = 'Bbl',
}
export const {
  usePostApprovalQuery,
  useGetApprovalByIdQuery,
  usePutApprovalByIdMutation,
  useGetApprovalApprovalhandlerByClientIdQuery,
  useGetApprovalAnnualByClientIdAndYearQuery,
  useGetApprovalByIdPdfQuery,
} = injectedRtkApi
